export const DATE_RANGE_OPTIONS = [
  { value: "today", label: "Hoy" },
  { value: "last_7_days", label: "Últimos 7 días" },
  { value: "last_30_days", label: "Últimos 30 días" },
  { value: "this_month", label: "Este mes" },
  { value: "previous_month", label: "Mes anterior" },
];

export const DEFAULT_DATE_RANGE = "last_30_days";

export const LAUNCH_STATUS_LABELS = {
  complete: "Completo",
  at_risk: "En riesgo",
  not_ready: "No listo",
};

export const ALERT_SEVERITY_LABELS = {
  high: "Alta",
  medium: "Media",
  low: "Baja",
};

export function trackAdminDashboardEvent(eventType, metadata = {}) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug("[admin-dashboard-event]", eventType, metadata);
  }
}

export function formatCop(value) {
  if (value == null) return "—";
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("es-CO", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(iso));
}

export function launchStatusClass(status) {
  if (status === "complete") return "admin-badge--success";
  if (status === "at_risk") return "admin-badge--warning";
  return "admin-badge--danger";
}

export function alertSeverityClass(severity) {
  if (severity === "high") return "admin-dashboard-alert--high";
  if (severity === "medium") return "admin-dashboard-alert--medium";
  return "admin-dashboard-alert--low";
}

export function formatPercent(value) {
  if (value == null) return "—";
  return `${value}%`;
}
